import { instantStatisticRequired } from '../../../../kinds/poll/questions/schemaFields';
import {
  createQuestionSchema,
  questionHasGratitude,
  questionRatingMaximum,
  questionRatingMinimum,
} from '../questionSchemaFields';
import { config } from './RatingSliderPoll.config';

export const schema = createQuestionSchema(
  {
    type: 'object',
    properties: {
      type: { enum: [config.name] },
    },
  },
  questionHasGratitude,
  questionRatingMaximum,
  questionRatingMinimum,
  instantStatisticRequired,
);
